import React, {useState} from 'react';

/**
 * Значение, которое при смене перекатывается: старое уезжает, новое приезжает
 * с другой стороны. Больше стало — катится вверх, меньше — вниз
 * @param {string|number} value - что показать
 * @param {number} rank - по чему сравнивать: у размера значение «1/10» не
 * число, сравнивается максимум
 */
export const RollingValue = ({value, rank}) => {
  const [roll, setRoll] = useState({value, rank, previousValue: null, isRising: true, count: 0});

  // Смена значения — состояние из пропа, на том же рендере (без кадра, где
  // новое значение уже стоит, а старое еще не уехало)
  if (roll.value !== value) {
    setRoll({
      value,
      rank,
      previousValue: roll.value,
      isRising: rank >= roll.rank,
      count: roll.count + 1,
    });
  }

  const direction = roll.isRising ? 'recruit-card_rolling_up' : 'recruit-card_rolling_down';

  return (
    <span className={`recruit-card_rolling ${direction}`}>
      {roll.previousValue !== null && (
        <span
          key={`out-${roll.count}`}
          className={'recruit-card_rolling-out'}
          aria-hidden={true}
          onAnimationEnd={() => setRoll((current) => ({...current, previousValue: null}))}
        >
          {roll.previousValue}
        </span>
      )}
      <span key={`in-${roll.count}`} className={roll.count > 0 ? 'recruit-card_rolling-in' : undefined}>
        {roll.value}
      </span>
    </span>
  );
};

export default RollingValue;
